import Theme from "../../theme";
import { Input, Box, Button, Spacer, Text, Grid } from "@flexisaf/flexibull2";
import { useForm } from "react-hook-form";
import LoginLayout from "../../components/LoginLayout";
import usePasswordRecovery from "../../hooks/password-recovery/usePasswordRecovery";
import { INSTITUTION_ID } from "../../utils/constants";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const { recoverPassword, isLoadingPasswordRecovery } = usePasswordRecovery();
  const [successInfo, setSuccessInfo] = useState(false);
  const {
    register,
    watch,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    defaultValues: {
      email: "",
    },
  });

  const handleForgotPassword = (v) => {
    const payload = {
      data: { username: v.email, institutionId: INSTITUTION_ID },

      callback: () => {
        setSuccessInfo(true);
      },
    };
    recoverPassword(payload);
  };
  return (
    <LoginLayout>
      <Box pad="32px">
        {!successInfo && (
          <>
            <Box pad="24px" align="center">
              <Text block capitalize size="1.8rem">
                Forgot Password
              </Text>
              <Spacer height={12} />
              <Text>
                Enter the email address associated with your account below
              </Text>
            </Box>
            <Input
              type="email"
              required
              block
              placeholder="Email"
              value={watch("email")}
              {...register("email", {
                required: "Email is required",
              })}
              error={errors.email?.message}
              onChange={({ target: { value } }) => setValue("email", value)}
            />

            <Grid responsive={false} default="auto max-content">
              <Box />

              <Box pad="8px 0">
                <a href="/login">
                  <Text
                    style={{ cursor: "pointer" }}
                    bold
                    color={Theme.PrimaryColor}
                  >
                    Back to login
                  </Text>
                </a>
              </Box>
            </Grid>
            <Spacer space="16px" />
            <Button
              block
              progress={isLoadingPasswordRecovery}
              onClick={handleSubmit((v) => handleForgotPassword(v))}
            >
              Submit
            </Button>
          </>
        )}
        {successInfo && (
          <Box>
            <Box align="center">
              <RiCheckboxCircleLine size="1.5rem" color={Theme.PrimaryColor} />
              <Text block size="1.5rem">
                Email sent
              </Text>
              <Spacer space="10px" />
              <Text block>
                Check your email and open the link we sent to continue
              </Text>
            </Box>
            <Spacer space="16px" />
            <Button block onClick={() => navigate("/")}>
              Back to home
            </Button>
          </Box>
        )}
      </Box>
    </LoginLayout>
  );
};

export default ForgotPassword;
